import React, { FC, FormEvent, useState } from 'react';

import { FormDialog, InputField } from '@Iot-Bee/standard-web-library';
import { Device } from '../../../Types/types';
import { isEnergySavingTool } from '../../../utils/typeUtils';

import { Box, Autocomplete, TextField } from '@mui/material';
import { standardTags } from '../util';

interface DeviceDialogProps {
  device: Device | null;
  open: boolean;
  onClose: () => void;
  onSave: (device: Device) => void;
}

const DeviceDialog: FC<DeviceDialogProps> = ({ device, open, onClose, onSave }) => {
  const [deviceData, setDeviceData] = useState<Device>(device ?? ({} as Device));

  const [typedTag, setTypedTag] = useState('');
  const { deviceName, id } = deviceData;

  const [selectedTag, setSelectedTag] = useState(device?.tags ? device.tags.split(', ')[0] : '');

  const handleTagChange = (_event: FormEvent, value: string | null) => {
    if (!value) {
      console.error("Tag can't be empty");
      return;
    }
    //setSelectedTag(event.target.value);
    setSelectedTag(value);
    setDeviceData((state) => ({
      ...state,
      tags: value,
    }));
  };

  const handleTagChangeByInput = (_event: FormEvent, value: string | null) => {
    if (!value) {
      console.error("Tag can't be empty");
      return;
    }
    //setSelectedTag(event.target.value);
    setTypedTag(value);
    setDeviceData((state) => ({
      ...state,
      tags: value,
    }));
  };

  return (
    <FormDialog
      title={`Update device`}
      buttonText={`Update device`}
      open={open}
      onClose={onClose}
      onSave={() => {
        onSave(deviceData);
        onClose();
      }}
      maxWidth="xs"
    >
      <Box sx={{ mb: 4 }}>
        <InputField
          label="Device name"
          value={deviceName}
          onChange={(value) =>
            setDeviceData((state) => ({
              ...state,
              deviceName: value,
            }))
          }
          fullWidth
          required
        />
      </Box>
      <Box sx={{ mb: 8 }}>
        <InputField
          label="ID"
          value={id}
          disabled
          onChange={(value) =>
            setDeviceData((state) => ({
              ...state,
              id: value,
            }))
          }
          required
          fullWidth
        />
      </Box>
      <Box sx={{ mb: 4 }}>
        {/*<Autocomplete
          multiple
          freeSolo
          options={displayedStandardTags}
          value={tags}
          inputValue={typedTag}
          onChange={handleTagChangeBySelect}
          onInputChange={handleTagChangeByInput}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Select or Create Tags"
              placeholder="Add a tag"
              onKeyDown={handleKeyDown}
            />
          )}
        />*/}
        {/*This is only for selecting single tags, the above one is for selecting multiple tags*/}
        {isEnergySavingTool(device?.deviceType) && (
          <Autocomplete
            freeSolo
            options={standardTags}
            value={selectedTag}
            inputValue={typedTag}
            onChange={handleTagChange}
            onInputChange={handleTagChangeByInput}
            renderInput={(params) => <TextField {...params} label="Tags" variant="outlined" fullWidth />}
            sx={{ width: '100%' }}
          />
        )}
      </Box>
    </FormDialog>
  );
};

export default DeviceDialog;
